import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { createAction } from '../../../utils';
import { OnlyBackButton } from '../../../components/base/BottomStepComponent';
import ContentSections from '../../../components/base/ContentSections';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';

function MessageCreditRecordDetail({
  messageRecord
}) {
  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id;
  const history = useHistory();

  const getDeepLink = () => {
    if (messageRecord?.message) {
      return `/messages/${messageRecord.message.pk}/`
    }
    if (messageRecord?.campaign) {
      return `/campaigns/${messageRecord.campaign.pk}/`
    }
  }
  const getSections = () => {
    let fields = [
      [{
        title: "Message",
        field: "displayMessageName",
        deeplink: getDeepLink(),
      }],
      [{
        title: "Admin",
        field: "displayMessageAdmin",
      }],
      [{
        title: "Message create date",
        field: "displayMessageCreationDate",
      }],
      [{
        title: "Credit consumed",
        field: "displayCreditConsum",
      }],
    ]
    let sections = [
      <MembershipInfoCard
        title={''}
        data={messageRecord}
        fields={fields}
      />,
      <MembershipInfoCard
        title={'GENERAL'}
        data={messageRecord}
        fields={[
          [{ title: 'Creation time', field: 'detailDisplayCreationDate' }],
        ]}
      />,
    ];
    return sections;
  };

  const tabs = [
    {
      name: '',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={getSections()}
            hidePreview={true}
          />
        </div>
      ),
    },
  ];
  useEffect(() => {
    dispatch({ type: 'messageCreditRecord/clearData' });
    return () => {
      dispatch({ type: 'messageCreditRecord/clearData' });

    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(createAction('messageCreditRecord/getOneDetail')({ id }));
  }, [dispatch, id]);

  return (
    <div>
      <CustomListComponent
        caution={{
          detail: "",
          title: messageRecord?.displayMessageName,
        }}
        defaultActiveKey={tabs[0].name}
        breadcrumb={<CustomBreadcrumb name={messageRecord?.displayMessageName} />}
        tabs={tabs}
      />
      <OnlyBackButton
        backAction={() => {
          history.push({
            pathname: '/message_credit_records',
          });
        }}
      />
    </div>
  );
}
const mapPropsToState = (state) => ({
  messageRecord: state.messageCreditRecord.detail,
});

export default connect(mapPropsToState)(MessageCreditRecordDetail);
